var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Bar',{attrs:{"id":"my-chart-id","chart-options":_vm.chartOptions,"chart-data":_vm.chartData,"width":_vm.width,"height":_vm.height}})
}
var staticRenderFns = []

export { render, staticRenderFns }